import { type FallbackProps } from 'react-error-boundary';
import { MessagePageComponent } from '../message-page/message-page.component';
import { ErrorFallbackComponent } from './error-fallback.component';

export const ErrorFallbackPageComponent = ({
  resetErrorBoundary,
  error,
}: FallbackProps) => {
  return (
    <MessagePageComponent>
      <ErrorFallbackComponent
        resetErrorBoundary={resetErrorBoundary}
        error={error}
      />
    </MessagePageComponent>
  );
};
